"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiToggleButtonOverrides = void 0;
var createMuiToggleButtonOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            border: undefined,
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: palette.action.hover,
            },
            "&$selected": {
                color: undefined,
                backgroundColor: palette.action.active,
            },
            "&.Mui-focusVisible": {
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
                backgroundColor: palette.action.focus,
            },
        },
        sizeSmall: {
            padding: spacing(1),
        },
    });
};
exports.createMuiToggleButtonOverrides = createMuiToggleButtonOverrides;
//# sourceMappingURL=MuiToggleButton.js.map